<!-- src/views/CheckoutSucesso.vue -->
<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-[#070a13] text-slate-100 text-center px-6">
    <div class="text-2xl font-semibold">Pagamento confirmado ✅</div>
    <div class="text-white/60 text-sm mt-2">Finalizando sua assinatura…</div>
  </div>
</template>

<script>
import axios from 'axios'
import { router } from '@/router'

export default {
  name: 'CheckoutSucesso',
  async mounted() {
    const token = localStorage.getItem('token')
    try {
      const urlParams = new URLSearchParams(window.location.search)
      const sessionId = urlParams.get('session_id')

      if (sessionId && token) {
        await axios.get('https://backend.controlease.com.br/api/billing/activate', {
          params: { session_id: sessionId },
          headers: { Authorization: `Bearer ${token}` },
        })
      }
    } catch (e) {
      console.warn('Ativação já pode ter sido feita via webhook, seguindo...')
    } finally {
      router.replace({ name: 'DashboardUser' })
    }
  },
}
</script>

<style scoped></style>
